<script>
  import { onMount } from "svelte";
  import List from "../components/List.svelte";
  /**
   * @typedef {Object} Props
   * @property {string} [url]
   */

  /** @type {Props} */
  let { url = "" } = $props();
  let data = $state(void 0);
  let loading = $state(true);
  let hasError = false;
  let errorMessage =
    "It looks like there is an error. We are not sure why this happened. Please try again or call our contact centre on 13 13 85.";
  let filterData = $state([]);

  onMount(() => {
    fetch(url)
      .then(async (res) => {
        if(res.ok) {
          let d = await res.json()
          data = d;
          filterData = d;
          loading = false;
        } else {
          throw new Error("Something went wrong");
        }
      })
      .catch((err) => {
        error = err;
        loading = false;
      });
  });
  const handleChange = (e) => {
    let filterTerm = e.target.value;
    if(data && filterTerm) {
      let d = filterTerm?.trim()?.split(" ")?.flatMap((term) =>
          data.flatMap((item) => {
            item.searchScore = 0;
            if (item.Location.toLowerCase().indexOf(term) !== -1) {
              item.searchScore += 2;
            } else if (item.ProjectTitle.toLowerCase().indexOf(term) !== -1) {
              item.searchScore += 3;
            } else if (item.ShortDescription.toLowerCase().indexOf(term) !== -1) {
              item.searchScore += 1;
            } else {
              return [];
            }
            return [item];
          }),
        )
        .sort(function (a, b) {
          return (b.searchScore || 0) - (a.searchScore || 0);
        })
        if(d) {
      filterData = d
    }
    }
    if(data && !filterTerm) {
      filterData = data
    }
  };
  const onsubmit = (e) => {e.preventDefault();}
</script>

<article>
  <form class="flex items-center w-full bg-white border border-grey rounded-full focus-within:outline-dashed focus-within:outline-2 focus-within:outline-ocean mb-20" {onsubmit}>
    <span class="hidden sm:inline sm:px-10">
      <svg class="fill-grey-500" xmlns="http://www.w3.org/2000/svg" id="UI-Icons-magnifier" width="20" height="20" viewBox="0 0 35.176 36">
          <path id="Path_544" data-name="Path 544" d="M588.513,607.344a2.168,2.168,0,0,1-1.577-.675l-8.45-8.812a2.187,2.187,0,0,1,.072-3.095,11.047,11.047,0,1,0-7.616,3.042,2.188,2.188,0,1,1,0,4.375,15.418,15.418,0,1,1,15.417-15.418,15.267,15.267,0,0,1-3.3,9.543l7.036,7.342a2.186,2.186,0,0,1-1.577,3.7Z" transform="translate(-555.524 -571.344)" />
      </svg>
    </span>
    <input
      class="w-full rounded-full pl-8 md:pl-2 text-[18px] lg:text-[22px] focus:outline-none"
      autocomplete="off"
      disabled={loading || hasError}
      oninput={handleChange}
      name="searchBox"
      placeholder="Enter a location, region or project name"
      type="search"
    />
    <button
      class="btn-primary px-10 sm:px-16 my-4 mr-4"
      type="submit"
    >{loading ? "...loading" : "Filter"}</button>
  </form>
  {#if hasError}
    <span>{errorMessage}</span>
  {/if}
  {#if !loading && !hasError && data && data.length > 0}
    <List list={filterData}/>
  {/if}
</article>
